import { Type } from 'class-transformer';
import { IsArray, IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';
import { BaseDto } from '../../@base';
import { UserHistoryId } from '../../types';
import { UserCreatedByPopulateDto } from '../users';

export class ChangeDto {
  @IsString()
  @IsNotEmpty()
  field!: string;

  @IsOptional()
  oldValue?: unknown;

  @IsOptional()
  newValue?: unknown;
}

export class UserHistoryDto extends BaseDto<UserHistoryId> {
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ChangeDto)
  changes!: ChangeDto[];

  @ValidateNested()
  @Type(() => UserCreatedByPopulateDto)
  @IsOptional()
  createdBy!: UserCreatedByPopulateDto;
}
